import BookReader from "../components/BookReader";

import { useEffect } from "react";

export default function ReaderFile({ setHeader }) {

  useEffect(() => {
    setHeader(false);
  }, []);

  return (
    <>
      <BookReader />

    </>
  );
}